import { runInAction } from 'mobx';
import ParametroSistemaApi from '../api/ParametroSistemaApi';
import { IParametroSistema } from '../modelo/ParametroSistema';
import ParametroSistemaStore from '../store/ParametroSistemaStore';

class ParametroSistemaService {


    async salvar(parametro: IParametroSistema) {
        return await ParametroSistemaApi.salvar(parametro);
    }

    async excluir(parametro: IParametroSistema) {
        return await ParametroSistemaApi.excluir(parametro);
    }

    public async todosParametros(): Promise<IParametroSistema[]> {
        const parametros = await ParametroSistemaApi.todosParametros();
        runInAction(() =>{
            ParametroSistemaStore.parametros = parametros;
        })
        return parametros;
    }

    async recuperaTiposPeticoesPendentes() {
        const tiposPeticoes = await ParametroSistemaApi.recuperaTiposPeticoesPendentes();
        return tiposPeticoes.sort((a, b) => {
            if (a.nomeTipoProcessoDocumento > b.nomeTipoProcessoDocumento) {
                return 1;
            } else if (a.nomeTipoProcessoDocumento < b.nomeTipoProcessoDocumento) {
                return -1;
            } else {
                return 0;
            }
        });
    }

    recuperaTiposImpedimentos(){
        return ParametroSistemaApi.recuperaTiposImpedimentos();
    }

    async recuperarParametrosCargos() {
        return ParametroSistemaApi.recuperarParametrosCargos();
    }
}

export default new ParametroSistemaService();
